import { render, staticRenderFns } from "./StackPage.vue?vue&type=template&id=d7211f76&scoped=true"
import script from "./StackPage.vue?vue&type=script&lang=js"
export * from "./StackPage.vue?vue&type=script&lang=js"
import style0 from "./StackPage.vue?vue&type=style&index=0&id=d7211f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7211f76",
  null
  
)

export default component.exports